import { render } from "./DocumentAlterRecord.vue?vue&type=template&id=6ad50204"
import script from "./DocumentAlterRecord.vue?vue&type=script&lang=js"
export * from "./DocumentAlterRecord.vue?vue&type=script&lang=js"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__